import axios from './indexFile'

class Excel {
    //渠道资金列表excel文件
    static distributorExcel(params) {
        return axios.get('/app-admin/distributor/query/downloadExcelUsingJson',{params:params,responseType: 'blob'})
    }
    //订单报表列表excel文件
    static ordersExcel(params) {
        return axios.get('/app-trains/order/order_export',{params:params,responseType: 'blob'})
    }
    //采购订单报表列表excel文件
    static purchaseOrdersExcel(params) {
        return axios.get('/app-trains/purchase/order_export',{params:params,responseType: 'blob'})
    }
    
}

export default Excel;
